import { createApp } from 'vue'
import { vue3Debounce } from 'vue-debounce'
import { vfmPlugin } from "vue-final-modal";
import { createI18n } from "vue-i18n/dist/vue-i18n.esm-bundler.js";
import { messages } from './i18n/messages'
import { useHttp, setStore, setRouter } from './composables/http'
import router from './router'
import store from './store'

import "bootstrap"

import "./assets/scss/_webapp.scss"
import "./assets/scss/palettes/_palettes.scss"

import WebApp from './App.vue'

const findLocale = () => {
    const storedLocale = localStorage.getItem(import.meta.env.PUBLIC_APP_CODE + '-locale');
    // Check if storedLocale is a valid string and not 'null' or 'undefined'
    if (storedLocale && storedLocale !== 'null' && storedLocale !== 'undefined') {
        return storedLocale;
    }
    // Return env locale or default to 'en'
    const envLocale = import.meta.env.PUBLIC_APP_LOCALE;
    return (envLocale && envLocale !== 'null' && envLocale !== 'undefined') ? envLocale : 'en';
}

// Add i18n
export const i18n = createI18n({
    legacy: false,
    locale: findLocale(),
    fallbackLocale: (import.meta.env.PUBLIC_FALLBACK_LOCALE && import.meta.env.PUBLIC_FALLBACK_LOCALE !== 'null' && import.meta.env.PUBLIC_FALLBACK_LOCALE !== 'undefined') ? import.meta.env.PUBLIC_FALLBACK_LOCALE : 'en',
    messages,
})

const app = createApp(WebApp);
const $http = useHttp();
setStore(store);
setRouter(router);
app.config.globalProperties.$axios = $http;
store.$axios = $http;

app
    .use(router)
    .use(i18n)
    .use(store)
    .use(vfmPlugin)
    .directive('debounce', vue3Debounce({ lock: true }));

app.mount('#app')
